module.exports = __webpack_public_path__ + "static/Chicory3-eb3408a478c090f0d3d22fb146c87576.webp";